import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'reset_password';

const changePsw = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "change_pwd" , data: params}, callback);
const process_new_password = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "process_new_password" , data: params}, callback);

const apiEndpoint = {
  changePsw,
  process_new_password
}

export default apiEndpoint;